document.querySelectorAll('.dropdown__header, .dropdown__backdrop').forEach(item => item.addEventListener('click', function () {
    const parent_el = this.closest('.dropdown');

    if (item.classList.contains('dropdown__backdrop')) {
        parent_el.classList.remove('active');
    }
    else {
        parent_el.classList.toggle('active');
    }

    const eventName = parent_el.classList.contains('active')
        ? 'dropdown_opened'
        : 'dropdown_closed';

    parent_el.dispatchEvent(new CustomEvent(eventName, {
        detail: { el: parent_el }
    }));
}));

document.querySelectorAll('.dropdown').forEach(dropdown => {
    const items = dropdown.querySelectorAll('.dropdown__item');
    const header = dropdown.querySelector('.dropdown__header');
    const isMulti = dropdown.hasAttribute('data-has-multi-selection');

    const defaultItem = dropdown.querySelector('.dropdown__item[data-value=""]');
    const defaultLabel = defaultItem ? defaultItem.textContent.trim() : '';

    if (defaultItem) {
        items.forEach(el => el.classList.remove('active'));
        defaultItem.classList.add('active');
        header.textContent = defaultLabel;
    }

    items.forEach(item => {
        item.addEventListener('click', function (e) {
            e.stopPropagation();
            const value = item.getAttribute('data-value');

            if (isMulti) {
                if (value === '') {
                    items.forEach(el => el.classList.remove('active'));
                    defaultItem.classList.add('active');
                    header.textContent = defaultLabel;

                    dropdown.dispatchEvent(new CustomEvent("dropdown_value_changed", {
                        detail: { el: dropdown, values: [], labels: [] }
                    }));

                    return;
                }

                item.classList.toggle('active');
                defaultItem.classList.remove('active');

                const selected = Array.from(items)
                    .filter(el => el.classList.contains('active') && el.getAttribute('data-value') !== "")
                    .map(el => ({
                        value: el.getAttribute('data-value'),
                        label: el.textContent.trim(),
                    }));

                if (selected.length) {
                    header.textContent = selected.map(s => s.label).join(', ');
                    header.classList.add('selected');
                }
                else {
                    header.textContent = defaultLabel;
                    defaultItem.classList.add('active');
                    header.classList.remove('selected');
                }

                dropdown.dispatchEvent(new CustomEvent("dropdown_value_changed", {
                    detail: {
                        el: dropdown,
                        values: selected.map(s => s.value),
                        labels: selected.map(s => s.label)
                    }
                }));

            } else {
                header.textContent = item.textContent.trim();
                header.classList.add('selected');

                items.forEach(el => el.classList.remove('active'));
                item.classList.add('active');

                dropdown.dispatchEvent(new CustomEvent("dropdown_value_changed", {
                    detail: {
                        el: dropdown,
                        value,
                        label: item.textContent.trim()
                    }
                }));

                dropdown.classList.remove('active');
            }
        });
    });
});